import React from "react";
import styles from "./Testimonials.module.css";

// Placeholder quotes — replace with real customer feedback once you have it.
// See README.md for instructions.
const QUOTES = [
  {
    quote:
      "Booked a post-renovation clean and the place was spotless afterwards — every corner, even the window tracks.",
    role: "Homeowner",
  },
  {
    quote:
      "Needed plumbing and painting done in the same week. One team handled both without any back-and-forth.",
    role: "Shop Owner",
  },
  {
    quote:
      "Quick reply on WhatsApp, fair quote, and they showed up exactly when they said they would.",
    role: "Office Manager",
  },
];

export default function Testimonials() {
  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.heading}>
          <p className="jc-eyebrow">Client Feedback</p>
          <h2 className={styles.title}>What customers say after the job's done</h2>
        </div>

        <div className="row g-4">
          {QUOTES.map((item) => (
            <div className="col-12 col-md-4" key={item.role}>
              <div className={styles.card}>
                <span className={styles.mark} aria-hidden="true">
                  “
                </span>
                <p className={styles.quote}>{item.quote}</p>
                <p className={styles.role}>— {item.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
